import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";

import TabPanel from "../../../../shared/UI/TabPanel";

import LocationsTab from "./components/LocationsTab";
import GeneralInfoTab from "./components/GeneralInfoTab";
import TabsNavigation from "./components/TabsNavigation";
import AchievementsTab from "./components/AchievementsTab";

const TABS = [
  {
    value: "general-info",
    component: <GeneralInfoTab />,
  },
  {
    value: "achievements",
    component: <AchievementsTab />,
  },
  {
    value: "locations",
    component: <LocationsTab />,
  },
];

const EntityProfileEdit = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get("tab") || "general-info";

  return (
    <Box sx={styles.container}>
      <TabsNavigation />
      {TABS.map((tab) => (
        <TabPanel key={tab.value} value={currentTab} tab={tab.value}>
          {tab.component}
        </TabPanel>
      ))}
    </Box>
  );
};

export default EntityProfileEdit;

const styles = {
  container: { width: "100%", display: "flex", flexDirection: "column", gap: "16px" },
};
